module.exports = __webpack_public_path__ + "static/media/1.dd2b8271.png";